export default "__VITE_ASSET__cc7b8f91__"